import React, { useMemo } from "react";
import OnIcon from "../../svgs/collections/OnIcon";
import OffIcon from "../../svgs/collections/OffIcon";
import EditIcon from "../../svgs/collections/EditIcon";

const IndustryCardExpanded = ({
  item,
  onShowClicked,
  onEditClicked,
  onMoveClicked,
  isShowLoading,
  isEditLoading,
}) => {
  // Mock tags - in real implementation, these would come from item data
  const tags = useMemo(() => {
    if (item?.subcategory) {
      return Array.isArray(item?.subcategory)
        ? item?.subcategory
        : [item?.subcategory];
    }
    if (item?.tags) {
      return Array.isArray(item?.tags) ? item?.tags : [item?.tags];
    }
    return [];
  }, [item]);

  return (
    <div
      className={`industryCard industryCard--expanded ${
        item?.show ? "industryCard--enabled" : "industryCard--disabled"
      }`}
    >
      {/* Header with logo, title and ID */}
      <div className="industryCard__header">
        <div className="industryCard__logo">
          {item?.logoStorage ? (
            <img src={item?.logoStorage} alt={item?.name} />
          ) : (
            <div className="industryCard__logo__placeholder">
              <span>{item?.name?.charAt(0)?.toUpperCase()}</span>
            </div>
          )}
        </div>
        <div className="industryCard__title">
          <h3>{item?.name || item?.title || "API Creation"}</h3>
        </div>
        <div className="industryCard__actions__date">
          <span className="industryCard__actions__date__label">
            {item?.generatedByAI ? "AI Generated" : "Manually"}
          </span>

          <span className="industryCard__actions__date__value">
            {item?.createdAt?.toDate()?.toLocaleDateString() || "2022-03-12"}
          </span>
        </div>
      </div>

      <div className="industryCard__content">
        {/* Rank and Tags on same row */}
        <div className="industryCard__rank-tags">
          {item?.rank >= 0 && (
            <span className="industryCard__rank">#{item?.rank}</span>
          )}

          {tags.map((tag, index) => (
            <span key={index} className="industryCard__tag">
              {tag}
            </span>
          ))}
        </div>

        {/* Description */}
        <div className="industryCard__description">
          <span className="industryCard__description__label">
            Description:{" "}
          </span>
          <p>
            {item?.description ||
              "Development of robust and scalable APIs to enable secure and efficient communication between systems and applications."}
          </p>
        </div>

        {/* Stats */}
        <div className="industryCard__stats">
          <div className="industryCard__stats__row">
            <span className="industryCard__stats__item">
              <strong>223</strong> companies
            </span>
            <span className="industryCard__stats__item">
              <strong>412</strong> partners
            </span>
            <span className="industryCard__stats__item">
              <strong>254</strong> jobs
            </span>
          </div>
          <div className="industryCard__stats__row">
            <span className="industryCard__stats__item">
              <strong>313</strong> case studies
            </span>
            <span className="industryCard__stats__item">
              <strong>278</strong> devs
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="industryCard__actions">
          <div className="industryCard__actions__left">
            <button
              onClick={() => onShowClicked?.(item)}
              disabled={isShowLoading}
              className={`industryCard__actions__toggle ${
                item?.show
                  ? "industryCard__actions__toggle--enabled"
                  : "industryCard__actions__toggle--disabled"
              }`}
            >
              {item?.show ? <OnIcon /> : <OffIcon />}
            </button>
            <button
              onClick={() => onEditClicked?.(item)}
              disabled={isEditLoading}
              className="industryCard__actions__edit"
            >
              <EditIcon />
            </button>
          </div>

          <button
            className="industryCard__actions__details"
            onClick={() => onMoveClicked?.(item)}
          >
            Move to another collection
          </button>
        </div>
      </div>

      {/* ID at bottom */}
      <div className="industryCard__bottom-id">
        <span>Id: {item?.ref?.id}</span>
      </div>
      <div className="industryCard__bottom-id">
        <span>Path: {item?.ref?.path}</span>
      </div>
    </div>
  );
};

export default IndustryCardExpanded;
